import { Routes } from '@angular/router';

//Componentes
import { PagesComponent } from 'components/layout/pages.component';

export const routes: Routes = [
    { path: '', loadChildren: () => import('./components/public/public.module').then(m => m.PublicModule) },
    { path: 'private', loadChildren: () => import('./components/private/pages.module').then(m => m.PagesModule) }
];
